<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-select #selectControl
            [(value)]='value'
            [placeholder]="placeholder"
            [ngModel]="selectControl"
            [disabled]="!parameterValue">

    <mat-option [value]="undefined">-- Select --</mat-option>
    <mat-option *ngFor="let opt of dropdownOptions$|async" [value]="opt.value">
        {{opt.text}}
    </mat-option>

    <div *ngIf="(selectControl.ngControl.invalid && (selectControl.ngControl.dirty || selectControl.ngControl.touched))" role="alert">
        <div *ngIf="selectControl.ngControl.hasError('pattern')">
            {{validationMessage}}
        </div>
        <div *ngIf="selectControl.ngControl.hasError('required')">
            {{field.displayName}} is required.
        </div>
    </div>

</mat-select>
